importScripts('openhps-core.js'); __WEBPACK_EXTERNAL_MODULE____ = self.OpenHPS.core;